//jwtToken.js
export function parseJwt(token: string) {
  // 1. Split into [header, payload, signature]
  const [, payload] = token.split('.')

  // 2. Base64-URL → Base64
  const base64    = payload.replace(/-/g, '+').replace(/_/g, '/')
  // 3. atob → percent-encoding → decodeURIComponent to handle UTF-8
  const json     = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => {
        return '%' + c.charCodeAt(0).toString(16).padStart(2, '0')
      })
      .join('')
  )
  // 4. Parse JSON
  return JSON.parse(json)
}

export function loadInitialAuthData() {
  let token = ""
  let expiry: Date | "" = ""
  let countryCode = ""
  let email ="";

  if (typeof window !== "undefined") {
    const raw = localStorage.getItem("auth_token") || ""
    if (raw) {
      try {
        const claims = parseJwt(raw)
        if (claims.exp) {
          const expDate = new Date(claims.exp * 1000)
          // only accept it if it's in the future
          if (expDate > new Date()) {
            token = raw
            expiry = expDate
            countryCode = claims.countryCode || ""
            email = claims.email
          }
        }
      } catch (err) {
        console.warn("loadInitialAuthData: invalid JWT, clearing it", err)
      }
    }
  }

  return { token, expiry, countryCode, email }
}
